import { render, staticRenderFns } from "./ModelChat.vue?vue&type=template&id=69c621bc&scoped=true"
import script from "./ModelChat.vue?vue&type=script&lang=js"
export * from "./ModelChat.vue?vue&type=script&lang=js"
import style0 from "./ModelChat.vue?vue&type=style&index=0&id=69c621bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c621bc",
  null
  
)

export default component.exports